<script>
import Layout from "../../../layouts/manage";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../../components/screen";
import Input from "@/components/c-input";
import Select from "@/components/c-select";
import Area from "@/components/c-input-area";
import Button from "@/components/c-button";

import { invoiceService } from "../../../../services/managements/invoices/invoice.service";
import { paymentService } from "../../../../services/managements/invoices/payment.service";
import { servicehelpers } from "../../../../services/servicehelpers";
import { propertyUtility } from "../../../../services/managements/propertyservice/propertyutility.service";
import { penaltySetting } from "../../../../services/managements/penaltysettings/penaltysetting.service";

import i18n from "../../../../i18n";
// import { propertyService } from '../../../../services/propertyservice/property.service';
// import Loading from "@/components/c-loading";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Payment Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Input,
    Select,
    Area,
    Button
    
    // Loading, 
  },
  data() {
    return {
      fetchingStats: true,
      tryingToSubmit: false,
      showDepositError: false,
      data: {},
      discountTypeData: {},
      propertyUtilityData: {},
      dataPenaltySetting: {},
      isOver: 0,

      dataCustomerId: 0,
      dataPropertyId: 0,
      dataInvoiceId: 0,
      dataTotalAmount: 0,
      dataDiscount: 0,
      dataPayableAmount: 0,
      dataReceiveAmount: 0,
      dataDebtAmount: 0,
      dataDueAmount: 0,
      dataCashAmount: 0,
      dataBankAmount: 0,
      dataChequeAmount: 0,
      dataDepositAmount: 0,
      dataNotation: '',
      dataDiscountText: '%',
      dataDiscountType: 1,
      dataTotalOverAmount: 0,
      dataOverDay: 0,
      dataCreatedBy: JSON.parse(localStorage.getItem('user'))
    };
  },
  mounted() {
    let hasId = 'id' in this.$route.params;
    if(hasId) {
      this.loadingData(this.$route.params.id);     
    }

    this.loadingDiscountTypeData();
  
  },

  watch: {
      dataDiscount: function() { // watch it
        this.changePayableAmount();
      },
      dataCashAmount: function() { // watch it
        this.changeReceiveAmount();
      },
      dataBankAmount: function() { // watch it
        this.changeReceiveAmount();
      },
      dataChequeAmount: function() { // watch it
        this.changeReceiveAmount();
      },
      dataDepositAmount: function(){
        // console.log(this.dataDepositAmount)
        let deposit = this.data.customer ? this.data.customer.deposit_amount : 0;
        if(this.dataDepositAmount > deposit){
          this.showDepositError = this.showDepositError ? false : true;
          this.$swal.fire({
              title: 'មិនត្រឹមត្រូវ',
              text: 'ចំនួនទឹកប្រាក់បានបង់ទុកមុន មិនអាចធំជាទឹកប្រាក់ដែលនៅសល់',
              icon: "warning",
              showConfirmButton: true,
              confirmButtonText: 'យល់ព្រម'
          }).then(result => {
              if (result.value) {
                this.dataDepositAmount = this.data.customer ? this.data.customer.deposit_amount : 0;
              }
          });
        }
        if(!this.showDepositError){
          this.changeReceiveAmount();
        }
      }
  },
 
  methods: {
    loadingData: function(id){
      this.fetchingStats = true;
      invoiceService.getOne(id)
        .then(response => {
          if(id != 0){
            console.log(response)
            this.data = response.data;
            let date_1 = new Date(this.data.invoice.expired_date);
            let date_2 = new Date();
            const days = (date_2, date_1) =>{
                let difference = date_1.getTime() - date_2.getTime();
                let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
                return TotalDays;
            }
            this.isOver = days(date_1, date_2);

            this.dataInvoiceId = this.data.invoice.id;
            this.dataPropertyId = this.data.invoice.property_id;
            this.dataCustomerId = this.data.customer ? this.data.customer.id: 0;
            this.dataTotalAmount = (this.total(this.data.invoice_detail.service, 'total_price') + this.total(this.data.invoice_detail.utility, 'total_price'));
            this.dataPayableAmount = (this.total(this.data.invoice_detail.service, 'total_price') + this.total(this.data.invoice_detail.utility, 'total_price'));
            // this.dataDepositAmount = this.data.customer ? this.data.customer.deposit_amount: 0;
          }
          this.loadPropertyUtility(id);
          this.loadPenaltySetting();
        }); 
    },
    loadPropertyUtility: function(id){
      let param = `?page=0&clause={"clause":[{"conjuction":"and","mg_property_utilities.invoice_id":{"value":${id}}}]}`;
       propertyUtility.getList(param).then(response => {
         this.propertyUtilityData = response.data[0];
        console.log(this.propertyUtilityData)
      });
    },
    loadingDiscountTypeData: function() {

      servicehelpers.getDiscountTypeData().then(response => {
        this.discountTypeData = response;
      });
    },

    discountTypeChanged: function(event) {

      const discountType = this.discountTypeData.data.find(obj => {
        return obj.id === event
      });

      this.dataDiscountText = discountType == null ? "" : discountType.name;
      this.changePayableAmount();
    }, 

    changePayableAmount: function() {
      if(this.dataDiscountType == 2) {
        this.dataPayableAmount = this.dataTotalAmount - this.dataDiscount;
      } else {
        this.dataPayableAmount = this.dataTotalAmount - (this.dataDiscount * this.dataTotalAmount / 100);
      }
    },

    changeReceiveAmount: function() {
      let receive_amount = Number(this.dataDepositAmount) + Number(this.dataCashAmount) + Number(this.dataBankAmount) + Number(this.dataChequeAmount);
      this.dataReceiveAmount = receive_amount;
      this.dataDebtAmount = (Number(receive_amount) < Number(this.dataPayableAmount)) ? Number(this.dataPayableAmount) - Number(receive_amount) : 0;
      this.dataDueAmount =  (Number(receive_amount) > Number(this.dataPayableAmount)) ? Number(receive_amount) - Number(this.dataPayableAmount) : 0; 
    },

    loadPenaltySetting: function(){
        penaltySetting.getOne(1)
        .then(response => {
         
            this.dataPenaltySetting = response.data
            this.dataOverDay = (this.isOver > 0 ) ? this.isOver : 0 ;
            if( this.dataOverDay > this.dataPenaltySetting.day_except){
              let days = this.dataOverDay - this.dataPenaltySetting.day_except;
              this.dataTotalOverAmount = days * this.dataPenaltySetting.amount;
              // this.dataTotalAmount += this.dataTotalOverAmount ;
              this.dataPayableAmount += this.dataTotalOverAmount ;
            }
        });
    },

    submitCancel: function() {
      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "manage-property"
          });

        }
      });
    
    },
    submitSave: function() {
      
      this.tryingToSubmit = true;
      if(this.dataPayableAmount != this.dataReceiveAmount){
        this.$swal.fire({
              title: 'មិនត្រឹមត្រូវ',
              text: 'អ្នកត្រូវតែបង់ប្រាក់គ្រប់ចំនួន',
              icon: "warning",
              showConfirmButton: true,
              confirmButtonText: 'យល់ព្រម'
          }).then(result => {
              if (result.value) {
                return false;
              }
          });
          this.tryingToSubmit = false;
          return false;
      }

      let dataSubmit = {
        invoice_id: this.dataInvoiceId,
        property_id: this.dataPropertyId,
        created_by: this.dataCreatedBy.id,
        discount: this.dataDiscount,
        discount_type_id: this.dataDiscountType,
        total_amount: this.dataTotalAmount,
        penalty_amount: this.dataTotalOverAmount,
        payable_amount: this.dataPayableAmount,
        receive_amount: this.dataReceiveAmount,
        debt_amount: this.dataDebtAmount,
        due_amount: this.dataDueAmount,
        deposit_amount: this.dataDepositAmount,
        cash_amount: this.dataCashAmount,
        bank_amount: this.dataBankAmount,
        cheque_amount: this.dataChequeAmount,

      };

      console.log(dataSubmit);

        paymentService.receivePayment(dataSubmit)
         .then(response => {
           this.tryingToSubmit = false;

           if(response.status == 200) {
              this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message'),
              icon: "success",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: i18n.t('general.success.yes'),
              cancelButtonText: i18n.t('general.success.no')
            }).then(result => {
              if (!result.value) {
                this.$router.go(-1) 
                //this.$router.push(this.$route.query.redirectFrom || {
                //   name: "manage-property"
                // });
              } 
            });
           }else{
            //  console.log(dataSubmit)

           }
          
        });
    
    },

    dateFormat: function(value){
      return this.$moment(String(value)).format('DD/MM/YYYY');
    },
    formatCurrency: function(value) {
      if(value == 0 ){
        return '0.00';
      }
      let sign = '$';
      let decimal = ''; //'.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);
    },
    print() {
      window.print();
    },
    total(data, column_name) {
      return data.reduce(function (sum,item) {
         return sum + item[column_name];
      }, 0);
    }
  },
};
</script>

<template>
  <Layout>
    <div>
      <PageHeader :items="[{
        text: $t('property.text'),
        href: '/manage/property',
      }, {
        text: $t('payment.text'),
        active: true
      }]" :title="$t('payment.text')" />
    </div>

    <Loading :loaded="fetchingStats" />
   
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm border p-3 me-1 " id="print-area">
                <!-- logo header  -->
                <section class="mb-3">
                  <table width="" class="content-general bottom m-auto">
                    <tr>
                      <td><img src="@/assets/images/h-logo.svg" alt width="80" /></td>
                      <td>
                        <p class="khb h4"><b>ក្រុមហ៊ុនលំនៅឋាន<span class="g-color"> អេចស៊ី </span>ឯ.ក</b></p>
                        <p class="enb h5"><b>LOMNOV THAN <span class="g-color">HC</span> CO., LTD</b></p>
                        <p class="khs h8">អាសយដ្ឋានដីឡូតិ៍លេខៈ ៧៤២ ផ្លូវលេខៈ ១៩៥២ ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ</p>
                        <p class="khs h8">ទូរស័ព្ទលេខៈ 015 55 40 77 | 078 55 40 77 Email: account@h-residence.net</p>
                      </td>
                    </tr>
                  </table>
                </section>
                <div class="row mb-3">
                  <div class="col">
                    <p class="khb h3 text-center"><u>{{$t('invoice.text')}}</u></p>
                  </div>
                </div>
                <!-- invoice primary info  -->
                <div class="row " v-if="data.invoice">
                  <div class="col-sm">
                    <div class="row">
                      <div class="col-4">
                        <p class="khs h5">{{$t('invoice.number')}}</p>
                        <p class="khs h5">{{$t('manage.room-no')}} </p>
                        <p class="khs h5"> {{$t('invoice.date')}}</p>

                      </div>
                      <div class="col">
                        <p class="khs h5 fw-bold text-primary">: {{data.invoice.code}}</p>
                        <p class="khs h5 fw-bold text-primary">: {{data.room_no}}</p>

                        <p class="khs h5">: {{dateFormat(data.invoice.invoice_date)}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm">
                    
                    <div class="row">
                      <div class="col-4">
                        <p class="khs h5"> {{$t('general.customer_name')}}</p>
                        <p class="khs h5"> {{$t('customer.phone-no')}}</p>
                        <p class="khs h5"> {{$t('customer.email')}}</p>
                      </div>
                      <div class="col" v-if="data.customer">
                        <p class="khs h5">: {{data.customer.name}}</p>
                        <p class="khs h5">: {{data.customer.phone_no_1}}{{data.customer.phone_no_2?'/'+data.customer.phone_no_2:''}}</p>
                        <p class="khs h5">: {{data.customer.email}}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- invoice body  -->
                <div class="row">
                  <div class="col-sm">
                    <table class="table table-bordered mb-3">
                      
                        <tr class="thead">
                          <th width="10">{{$t('general.number')}}</th>
                          <th>{{$t('manage.service.text')}}</th>
                          <th width="20">{{$t('invoice.quantity')}}</th>
                          <th>{{$t('invoice.price')}}</th>
                          <th>{{$t('invoice.total')}}</th>
                        </tr>
                      
                      <tbody v-if="this.data.invoice_detail">
                        <tr v-for="(data, index) in data.invoice_detail.service" :key="index">
                          <td>{{index + 1}}</td>
                          <td>{{data.name}}</td>
                          <td>{{data.quantity}}</td>
                          <td>{{formatCurrency(data.price)}}</td>
                          <td>{{formatCurrency(data.total_price)}}</td>
                        </tr>
                        
                      </tbody>
                        <tr v-if="this.data.invoice_detail" class="tfoot">
                          <td colspan="4" class="khs fw-bolder text-end">
                            {{$t('invoice.amount')}}
                          </td>
                          <td>{{formatCurrency(total(data.invoice_detail.service, 'total_price'))}}</td>
                        </tr>
                    </table>

                    <table class="table table-bordered" v-if="this.data.invoice_detail.utility.length">
                      
                        <tr class="thead">
                          <th colspan="2">{{$t('manage.start-date')}} {{dateFormat(propertyUtilityData.start_date)}} - {{$t('manage.end-date')}} {{dateFormat(propertyUtilityData.end_date)}}</th>
                          <th >{{$t('manage.utility.old-record')}}</th>
                          <th >{{$t('manage.utility.new-record')}}</th>
                          <th >{{$t('manage.utility.used')}}</th>
                          <th>{{$t('invoice.price')}}</th>
                          <th>{{$t('invoice.total')}}</th>
                        </tr>
                      
                      <tbody v-if="data">
                        <tr v-for="(data, index) in data.invoice_detail.utility" :key="index">
                          <td>{{index + 1}}</td>
                          <td>{{data.name}}</td>
                          <td>{{data.old_record}}</td>
                          <td>{{data.new_record}}</td>
                          <td>{{data.quantity}}</td>
                          <td>{{formatCurrency(data.price)}}</td>
                          <td>{{formatCurrency(data.total_price)}}</td>
                        </tr>
                      </tbody>
                        <tr class="tfoot">
                          <td colspan="6" class="khs fw-bolder text-end">
                            {{$t('invoice.amount')}}
                          </td>
                          <td>{{formatCurrency(total(data.invoice_detail.utility, 'total_price'))}}</td>
                        </tr>
                        <tr class="tfoot">
                           <td colspan="6" class="khs fw-bolder text-end">
                             {{$t('payment.pay-amount')}}
                           </td>
                          <td>{{formatCurrency(total(data.invoice_detail.service, 'total_price') + total(data.invoice_detail.utility, 'total_price'))}}</td>
                        </tr>
                    </table>
                  </div>
                </div>

              </div>
              <div class="col-sm-4 border p-3">
                <div class="row">
                  <div class="col-sm">
                    <!-- <p class="text-end"> </p> -->
                  <div class="row">
                    <div class="col">
                       <p class="khb h4 text-start">
                        <u>{{$t('payment.text')}}</u>
                      </p>
                    </div>
                    <div class="col">
                      <p class="text-end text-danger">{{this.data.customer ? 'ប្រាក់បានដាក់: ' + formatCurrency(this.data.customer.deposit_amount) : '0.00'}}</p>
                    </div>
                  </div>
                   
                   
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm">
                    <Input 
                      :type="'number'"
                      :id="'total_over_amount'"
                      :disabled="true"
                      v-model="dataOverDay"
                      :label="'manage.penalty-setting.over-day'"
                    />
                  </div>
                  <div class="col-sm">
                      <Input 
                      :type="'number'"
                      :id="'total_over_amount'"
                      :disabled="true"
                      v-model="dataTotalOverAmount"
                      :last="'$'"
                      :label="'manage.penalty-setting.penalty-amount'"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm">
                    <Input 
                      :type="'number'"
                      :id="'total_amount'"
                      :disabled="true"
                      v-model="dataTotalAmount"
                      :last="'$'"
                      :label="'invoice.amount'"
                    />
                  </div>
                  <div class="col-sm">
                     <Input 
                      :type="'number'"
                      :id="'payable_amount'"
                      :disabled="true"
                      v-model="dataPayableAmount"
                       :last="'$'"
                      :label="'manage.payable-amount'"
                    />
                  </div>
                </div>
                 <div class="row">
                  <div class="col-sm">
                    <Input 
                      :type="'number'"
                      :id="'discount'"
                      v-model="dataDiscount"
                      :last="this.dataDiscountText"
                      :label="'payment.discount'"
                    />
                   
                  </div>
                  <div class="col-sm">
                    <Select
                      @change="discountTypeChanged" 
                      :id="'discount_type'"
                      :text="'name'"
                      :auto="true"
                      v-model="dataDiscountType"
                      :list="this.discountTypeData"
                       :last="'$'"
                      :label="'sale.as'"
                      /> 
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm">
                    <div class="row">
                      <div class="col">
                          <Input 
                            :type="'text'"
                            :id="'customer_deposit_amount'"
                            v-model="dataDepositAmount"
                            :disabled="(this.data.customer && this.data.customer.deposit_amount) ? false : true"
                            :last="'$'"
                            :label="'manage.customer-deposit.current-deposit-amount'"
                          />
                          
                      </div>
                      <div class="col">
                          <Input 
                          :type="'text'"
                          :id="'cash_amount'"
                          v-model="dataCashAmount"
                          :last="'$'"
                          :label="'general.cash'"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm">
                        <Input 
                            :type="'text'"
                            :id="'bank_amount'"
                            v-model="dataBankAmount"
                            :label="'payment.bank_account'"
                          />
                      </div>
                      <div class="col-sm">
                         <Input 
                          :type="'text'"
                          :id="'cheque_amount'"
                          v-model="dataChequeAmount"
                          :last="'$'"
                          :label="'manage.cheque'"
                        />
                      </div>
                   </div>
                  </div>
                
                </div>
                
                <div class="row">
                  <div class="col-sm">
                     <Area   
                      :rows="5"
                      :id="'address'"
                      v-model="dataNotation"
                      :label="'booking.notation'"  />
                  </div>
                </div>
                <div class="row ">
                  <div class="col-sm">
                    <p class="khb h4">{{$t('manage.receive-amount')}}: </p>
                    <!-- <p class="khb h4">{{$t('manage.debt-amount')}}: </p> -->
                    <p class="khb h4">{{$t('manage.due-amount')}}: </p>
                    
                  </div>
                  <div class="col-sm">
                    <p class="khb h4">{{formatCurrency(dataReceiveAmount)}}</p>
                    <!-- <p class="khb h4">{{formatCurrency(dataDebtAmount)}}</p> -->
                    <p class="khb h4">{{formatCurrency(dataDueAmount)}}</p>
                  </div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-x-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.cancel')"  />
                    </div>
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="submitSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.save')"  />
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </b-form> 
  </Layout>
</template>